import { render, staticRenderFns } from "./PlatformSignUp.vue?vue&type=template&id=cfa7afe6&scoped=true"
import script from "./PlatformSignUp.vue?vue&type=script&lang=js"
export * from "./PlatformSignUp.vue?vue&type=script&lang=js"
import style0 from "./PlatformSignUp.vue?vue&type=style&index=0&id=cfa7afe6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa7afe6",
  null
  
)

export default component.exports